import { noAuthApi } from '@/shared/api/noAuthApi';
import { OtpChannel } from '@/shared/lib/otp/cooldowns';

export interface StartQuery {
  phoneNumber: string;
  captcha: string;
  channel?: string;
}
export interface Step1Query {
  registrationToken: string;
  code: string;
}
export interface Step2Query {
  registrationToken: string;
  nickname: string;
  password: string;
}

export interface TokenResponse {
  registrationToken: string;
}

export interface StartResponse extends TokenResponse {
  maxDeepLink?: string;
  channel: OtpChannel;
  retryAfterSeconds: number;
  canResend: boolean;
  remainingAttempts: number;
}

export type ResendChannel = OtpChannel;

export interface ResendCodeQuery {
  registrationToken: string;
  channel: ResendChannel;
}

export interface ResendCodeResponse {
  channel: ResendChannel;
  retryAfterSeconds: number;
  canResend: boolean;
  remainingAttempts?: number;
  lockedUntil?: number;
}

const registrationApi = noAuthApi.injectEndpoints({
  endpoints: (build) => ({
    start: build.mutation<StartResponse, StartQuery>({
      query: (data) => ({
        url: '/v1/portal/registration/start',
        method: 'POST',
        body: data,
      }),
    }),
    step1: build.mutation<TokenResponse, Step1Query>({
      query: (data) => ({
        url: '/v1/portal/registration/step-1',
        method: 'POST',
        body: data,
      }),
    }),
    step2: build.mutation<void, Step2Query>({
      query: (data) => ({
        url: '/v1/portal/registration/step-2',
        method: 'POST',
        body: data,
      }),
    }),
    resendCode: build.mutation<ResendCodeResponse, ResendCodeQuery>({
      query: (data) => ({
        url: '/v1/portal/registration/resend-code',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useStartMutation, useStep1Mutation, useStep2Mutation, useResendCodeMutation } = registrationApi;
